import { render } from "./MoveColumnModal.vue?vue&type=template&id=655594f6&scoped=true"
import script from "./MoveColumnModal.vue?vue&type=script&lang=js"
export * from "./MoveColumnModal.vue?vue&type=script&lang=js"

import "./MoveColumnModal.vue?vue&type=style&index=0&id=655594f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655594f6"]])

export default __exports__